export const GET_ACCOUNT_STATEMENT = 'GET_ACCOUNT_STATEMENT';
export const GET_ACCOUNT_STATEMENT_SUCCESS = 'GET_ACCOUNT_STATEMENT_SUCCESS';
export const GET_ACCOUNT_STATEMENT_ERROR = 'GET_ACCOUNT_STATEMENT_ERROR';

export const POST_ACCOUNT_STATEMENT = 'POST_ACCOUNT_STATEMENT';
export const POST_ACCOUNT_STATEMENT_SUCCESS = 'POST_ACCOUNT_STATEMENT_SUCCESS';
export const POST_ACCOUNT_STATEMENT_ERROR = 'POST_ACCOUNT_STATEMENT_ERROR';

export const SET_ACCOUNT_STATEMENT_FILTERS = 'SET_ACCOUNT_STATEMENT_FILTERS';